import { ContentBlock } from '../../../lib/types/aemDataModels';
import { WithValidated } from '../../../lib/types/helperTypes';
import PureLink, { PureLinkVariant } from '../Link/PureLink';
import PureAsset from '../PureAsset/PureAsset';
import PureRichText from '../PureRichText/PureRichText';
import styles from './ContentBlockView.module.scss';
import { SCALE } from '../Image/ImageScale';

export type ContentBlockViewProps = {
  contentBlock: ContentBlock | null;
  headingHidden?: boolean;
  contentHidden?: boolean;
  ctaHidden?: boolean;
  assetHidden?: boolean;
};
export type ValidatedContentViewProps = WithValidated<ContentBlockViewProps, 'contentBlock'>;

const ContentBlockView = ({
  contentBlock,
  headingHidden,
  contentHidden,
  ctaHidden,
  assetHidden,
}: ValidatedContentViewProps) => {
  const { heading, content, link, linkLabel, asset, video } = contentBlock;

  return (
    <>
      {!headingHidden && !!heading && <h3 className={styles.heading}>{heading}</h3>}
      {!contentHidden && !!content && <PureRichText richtext={content} richtextClass={styles.richtext} />}
      {!ctaHidden && !!link && !!linkLabel && (
        <PureLink href={link} variant={PureLinkVariant.Link}>
          {linkLabel}
        </PureLink>
      )}
      {!assetHidden && (!!asset || !!video) && (
        <div className={styles.assetContainer}>
          <PureAsset
            asset={asset}
            video={video}
            imageProps={{ imageClassName: styles.imageAsset }}
            imageScale={SCALE.CONTENT_BLOCK}
          />
        </div>
      )}
    </>
  );
};

export default ContentBlockView;
